import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import history from '../../../route/history'
import Input from '../../../module/input'
import { memberAppActions } from '../../../store/actions/main/memberApp.actions'

import { alertActions, authActions, regisActions, govCertapplyActions, userinfoActions} from '../../../store/actions'
import { commons } from '../../../hook/common'
import moment from 'moment'
import KTnetModal3 from '../../../module/ktnet/KTnetModal3'
import $ from 'jquery'
import * as common from '../../../assets/js/common.js'

import ico_eye from '../../../assets/images/sub/eye_1.png'
import ico_eye_slash from '../../../assets/images/sub/eye_slash_1.png'

const LoginCorp = (props) => {
  // 공인인증 툴킷open 여부

  const [isKTnetOpen, setIsKTnetOpen] = useState(false)
  const [pType, setPType] = useState('password')
  const [deviceId, setDeviceId] = useState('')

  let [state, setState] = useState({
    userName: '',
    password: '',
    isSaveId: false,
    submitted: false,
    data: null,
    crtfctDetailList: [],
    selectedCrtfctInfo: '',
    crtfctPassword: '',
    editableColor: '',
    selected: false,
  })

  useEffect(() => {
    if (common.getDeviceType() === 'MobileApp') {
      let uuid = window.M.info.device('uuid')
      checkUuid(uuid)
      setDeviceId(window.M.info.device('uuid'))
    }
  }, [])

  const checkUuid = (param) => {    
    props.checkUuid(param)
  }

  const [active, setActive] = useState(1)

  useEffect(() => {
    setState({ ...state, data: props.auth })
  }, [props.auth])

  useEffect(() => {
    let userInfo = localStorage.getItem('user')

    if (commons.isMobile() && userInfo != null) {
      props.logOut()
    }

    let lastLogin = localStorage.getItem('lastLogin')
    let userId = localStorage.getItem('saveId')

    if (lastLogin) {
      let today = moment().hour(0).minute(0).second(0).millisecond(0)
      let day = moment.duration(today.diff(moment(lastLogin))).asDays()

      if (day > 7) {
        localStorage.removeItem('saveId')
        localStorage.removeItem('lastLogin')
        userId = null
      }
    }

    userId && setState({ ...state, userName: userId, isSaveId: true })
  }, [])

  const handleChange = (e) => {
    const { name, value } = e.target
    setState({
      ...state,
      [name]: value,
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    const { userName, password, isSaveId } = state

    if (!userName) return props.error({ message: '아이디를 입력하세요.' })
    if (!password) return props.error({ message: '비밀번호를 입력하세요.' })

    setState({
      ...state,
      submitted: true,
    })
    props.logInCorp(userName, password, isSaveId)
  }

  const openUth = () => {
    if (commons.isMobile()) {
      history.push('/openLink')
    }
  }

  const checkHandler = (e) => {
    const { id, checked } = e.target

    setState({
      ...state,
      [id]: checked,
    })
  }

  //tab
  let [step, setStep] = useState(1)

  const onSelected = (value) => {
    setStep(value)
  }

  /**
   * 인증서 콜백
   * @param info
   */
  const crtfctInfo = (info) => {
    props.passCrtfctfLogin(info, '2',"N")
  }

  useEffect(() => {
    $('#loginSelect').on('click', function () {
      $(this).toggleClass('on off')
    })
    $('#loginList li').on('click', function () {
      $('#loginSelect').removeClass('on')
      $('#loginSelect').text($(this).text())
    })
  }, [])

  //인증서 목록 가져오기
  useEffect(() => {
    if (common.getDeviceType() === 'MobileApp') {
      window.M.execute(
        'exWNGetCertList',
        window.M.response
          .on(function (status, result) {
            //window.M.pop.alert('status : ' + status + ', result : ' + JSON.stringify(result.data.certList));
            if (status === 'SUCCESS') {
              setState({ ...state, crtfctDetailList: result.data.certList })
            }
          })
          .toString(),
      )
    }
  }, [])

  function setMobileCrtfct() {
    let paramUrlCode = props.location?.search?.split("=")[0]
    let paramEcdwAdres = props.location?.search?.split("=")[1]

    const { crtfctPassword } = state
    if (!crtfctPassword) return props.error({ message: '비밀번호를 입력하세요.' })
    var subjectDn = state.selectedCrtfctInfo.subjectDn //document.getElementById("subjectDn").value
    console.log('subjectDn : ', subjectDn)
    var data = new Date().toISOString().substr(0, 10).replace('T', ' ')
    if(paramUrlCode !== ""){
      data = paramEcdwAdres
    }
    var loginData = ''
    async function temp(myData){
      let paramsTest2 = {}
        await window.M.execute(
          'exWNMakeSignData',
          subjectDn,
          myData,
          crtfctPassword,
          window.M.response
            .on(function (status, result) {
              loginData = result.data.signData
              props.setSignData(loginData)
              // Object.assign(paramsTest2,{url:'Login.js 843'})
              // Object.assign(paramsTest2,{loginData:loginData})
              // axios.post(uriConstants.API_URI+'/portal/blockchain/logTest',paramsTest2,{headers:{},})
              let user = JSON.parse(localStorage.getItem('user'))
              user.payload.signData = loginData
              localStorage.setItem('user',JSON.stringify(user))
              // history.replace('/')
              document.location.href = '/'
            })                                                                  
            .toString(),
        )
        return ''
      }
    if (window.M.navigator.device('ios')) {
      window.M.execute(
        'exWNMakeSignData',
        subjectDn,
        data,
        crtfctPassword,
        window.M.response
          .on(function (status, result) {
            loginData = result.data.signData
            console.log('status', status)
            console.log('result', result)
            //window.M.pop.alert('status : ' + status + ', result : ' + JSON.stringify(result));
            if (status === 'SUCCESS') {
              if(paramUrlCode !== ""){
                props.setSignData(loginData)
                let tempUserStr = localStorage.getItem('user')
                if(tempUserStr){
                  let tempUser = JSON.parse(tempUserStr)
                  tempUser.payload.signData = loginData
                  localStorage.setItem('user',JSON.stringify(tempUser))
                }
                const params = {
                  deviceId: deviceId,
                  ecdwAdres: paramEcdwAdres,
                  signedData: loginData,
                  urlCode: paramUrlCode,
                }
                // 지갑 화면 URL 요청
                props.getScreenURL(params)
              }else{
                props.passCrtfctfLoginIos(loginData, '2', "Y",temp)
              }
            } else {
              crtfctFail()
            }
          })
          .toString(),
      )
    } else if (window.M.navigator.device('android')) {
      window.M.execute(
        'exWNMakeSignData',
        subjectDn,
        data,
        crtfctPassword,
        window.M.response
          .on(function (status, result) {
            loginData = result.data.signData
            console.log('status', status)
            console.log('result', result)
            //window.M.pop.alert('status : ' + status + ', result : ' + JSON.stringify(result));
            if (status === 'SUCCESS') {
              if(paramUrlCode !== ""){
                props.setSignData(loginData)
                let tempUserStr = localStorage.getItem('user')
                if(tempUserStr){
                  let tempUser = JSON.parse(tempUserStr)
                  tempUser.payload.signData = loginData
                  localStorage.setItem('user',JSON.stringify(tempUser))
                }
                const params = {
                  deviceId: deviceId,
                  ecdwAdres: paramEcdwAdres,
                  signedData: loginData,
                  urlCode: paramUrlCode,
                }
                // 지갑 화면 URL 요청
                props.getScreenURL(params)
              }else{
                props.passCrtfctfLogin(loginData, '2', "Y",temp)
              }
            } else {
              crtfctFail()
            }
          })
          .toString(),
      )
    }
  }

  const handleClick = (info, index) => {
    setState({
      ...state,
      selected: true,
      selectedCrtfctInfo: info,
      crtfctDetailList: state.crtfctDetailList.map((detail, idx) =>
        idx === index ? { ...detail, editableColor: '#B0ECFF' } : { ...detail, editableColor: '' },
      ),
    })

    //    setState({ ...state, selected: true, editableColor: '#B0ECFF', selectedCrtfctInfo: info })
  }

  /**
   * 네이티브 화면 메시지 처리
   */
  const crtfctFail = () => {
    props.success({
      title: '확인',
      message: ' 인증서 검증에 실패하였습니다',
      params: {
        type: 'SUCCESS',
        callback: () => {
          return
        },
      },
    })
  }

  return (
    <React.Fragment>
      {/* container */}
      <div id="container">
        {/* contents */}
        <div id="contents">
          <div className="content-header type2">
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault()
                window.history.back()
              }}
              className="page-prev"
            >
              뒤로이동
            </a>
            {/* <!-- mobile --> */}
            <h2>로그인</h2>
            <div className="breadcrumb">
              <span>Home</span>
              <em>로그인</em>
            </div>
          </div>
          <div className="login-wrap">
            <ul className="nav-tab tabs">
              <li
                className={step === 1 ? 'on' : ''}
                onClick={() => {
                  onSelected(1)
                }}
              >
                <a className="cursor">아이디</a>
              </li>
              <li
                className={step === 2 ? 'on' : ''}
                onClick={() => {
                  onSelected(2)
                }}
              >
                <a className="cursor">공동인증서</a>
              </li>
            </ul>
            {/* <!-- mobile --> */}
            <div className="nav-wrap">
              <a href="#" id="loginSelect" className="current-menu on">
                아이디
              </a>
              <ul className="nav-menu" id="loginList">
                <li className="on">
                  <a
                    href="#"
                    onClick={() => {
                      onSelected(1)
                    }}
                  >
                    아이디
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    onClick={() => {
                      onSelected(2)
                    }}
                  >
                    공동인증서
                  </a>
                </li>
              </ul>
            </div>

            {/* <!-- //mobile --> */}
            <div className="tab-container">
              {step === 1 && (
                <div id="login-tab1" className="tab-cont">
                  <div className="login-cont">
                    <div className="login-input">
                      <form name="form" onSubmit={handleSubmit}>
                        <fieldset style={{ position: 'relative' }}>
                          <Input
                            type={'text'}
                            id="userName"
                            name="userName"
                            value={state.userName}
                            className="form-control input-text"
                            placeholder="아이디"
                            message={'아이디를 입력하세요'}
                            onChange={(e) => handleChange(e)}
                            required={true}
                            numberOnly={false}
                            inputTitle={'아이디 입력'}
                            flow={`${window.innerWidth >= 767 ? 'left' : 'up'}`}
                            submitted={state.submitted}
                          />
                          <Input
                            type={pType}
                            id="password"
                            name="password"
                            value={state.password}
                            className="form-control input-text"
                            placeholder="비밀번호"
                            inputTitle={'비밀번호 입력'}
                            message={'비밀번호를 입력하세요'}
                            onChange={(e) => handleChange(e)}
                            required={true}
                            numberOnly={false}
                            flow={`${window.innerWidth >= 767 ? 'left' : 'up'}`}
                            submitted={state.submitted}
                          />
                          <img
                            src={pType === 'password' ? ico_eye : ico_eye_slash}
                            alt=""
                            className="pc-only"
                            onClick={(e) => {
                              e.preventDefault()
                              setPType(pType === 'password' ? 'text' : 'password')
                            }}
                            style={{
                              position: 'absolute',
                              right: '-20px',
                              bottom: '65px',
                              maxWidth: '30px',
                            }}
                          />
                          {/* <button
                            type="button"
                            onClick={(e) => {
                              e.preventDefault()
                              setPType(pType === 'password' ? 'text' : 'password')
                            }}
                            style={{
                              position: 'absolute',
                              right: '-50px',
                              bottom: '65px',
                            }}
                          >
                            보이기
                          </button> */}
                          <div className="idsave">
                            <input id="isSaveId" type="checkbox" checked={state.isSaveId} onChange={checkHandler} />
                            <em />
                            <label htmlFor="isSaveId">아이디 저장</label>
                            {/*  {isMobile && (
                              <a href="/LoginPass" className="link-arr float-r">
                                간편비밀번호 로그인 <BsChevronRight />
                              </a>
                            )} */}
                          </div>
                        </fieldset>
                        <button className="btn-login">로그인</button>
                      </form>
                      <div className="idpw_list">
                        <a href="https://wallet.utradehub.or.kr/regis/join">회원가입</a>
                        <a href="/find/id?gbn=2">아이디 찾기</a>
                        <a href="/find/pass?gbn=2">비밀번호 찾기</a>
                      </div>
                    </div>
                  </div>
                  <div className="guide-box gray">
                    <dl className="dlist1">
                      <dt>이용안내</dt>
                      <dd>회원님의 개인정보보호를 위해 일정시간(약 30분) 동안 이용하지 않으면 자동 로그아웃 됩니다.</dd>
                      <dd>회원님의 암호는 주기적으로 변경하고 타인에게 노출되지 않도록주의하시 바랍니다.</dd>
                      <dt>소셜 로그인 이용안내</dt>
                      <dd>소셜 로그인은 전자문서지갑 회원 중 소셜 계정 연동 후 이용이 가능합니다.</dd>
                      <dd>‘마이페이지 → 로그인설정 → SNS로그인 설정’에서 계정 연동이 가능합니다.</dd>
                    </dl>
                  </div>
                </div>
              )}
              {step === 2 &&
                (common.getDeviceType() === 'MobileApp' ? (
                  <div id="login-tab2" className="tab-cont">
                    {state.crtfctDetailList.length > 0 ? (
                      <div className="certify-wrap" style={{ marginTop: '40px' }}>
                        <ul className="certify-list">
                          {state.crtfctDetailList.map((info, index) => (
                            <li onClick={() => handleClick(info, index)} style={{ backgroundColor: info.editableColor }}>
                              <a href="#">
                                <div className="box">
                                  <div className="img"></div>
                                  <div className="info">
                                    <dl key={index}>
                                      <dt>
                                        {info.subjectDn.split('=')[1].split('(')[0]}
                                        <input type="hidden" id="subjectDn" name="subjectDn" value={info.subjectDn} />
                                      </dt>
                                      <dd>{info.issuerDn.split('=')[3].split(',')[0]}</dd>
                                      <dd>만료일 : {moment(info.notAfter).format('YYYY.MM.DD')}</dd>
                                    </dl>
                                  </div>
                                </div>
                              </a>
                            </li>
                          ))}
                        </ul>
                        {
                          <>
                            <div className="certify-password">
                              <p className="tit">인증서 비밀번호를 입력하세요.</p>
                              <input
                                type="password"
                                className="form-keyword"
                                title={'비밀번호 입력'}
                                id="crtfctPassword"
                                name="crtfctPassword"
                                value={state.crtfctPassword}
                                onChange={(e) => handleChange(e)}
                              />
                            </div>
                            <div className="common-login">
                              <a className="btn-primary sm cursor" onClick={setMobileCrtfct}>
                                로그인
                              </a>
                            </div>
                          </>
                        }
                      </div>
                    ) : (
                      <div className="common-login">
                        <dl className="desc">
                          <dt>공동인증서 로그인</dt>
                          <dd>
                            전자문서지갑 회원 대상으로,
                            <br /> 홈페이지에 <strong>최초 1회 인증서 등록 후</strong> 이용 가능합니다.
                          </dd>
                        </dl>
                      </div>
                    )}
                    <div className="guide-box gray">
                      <dl className="dlist1">
                        <dt>이용안내</dt>
                        <dd>은행인증서(무료) 또는 범용인증서(유료) 모두 이용 가능합니다.</dd>
                        <dd>비밀번호 5회 이상 입력 오류 시 재시도 해주시기 바랍니다.</dd>
                        <dt>공동인증서 로그인 안내</dt>
                        <dd>인증서 로그인은 전자문서지갑 회원 중 인증서를 등록한 경우 이용 가능합니다.</dd>
                        <dd>'마이페이지 → 인증서관리 → 인증서 등록'에서 등록이 가능합니다.</dd>
                      </dl>
                    </div>
                  </div>
                ) : (
                  <div id="login-tab2" className="tab-cont">
                    <div className="common-login">
                      <dl className="desc">
                        <dt>공동인증서 로그인</dt>
                        <dd>
                          전자문서지갑 회원 대상으로,
                          <br /> 홈페이지에 <strong>최초 1회 인증서 등록 후</strong> 이용 가능합니다.
                        </dd>
                      </dl>
                      {
                        <a
                          className="btn-primary sm cursor"
                          onMouseDown={() => {
                            setIsKTnetOpen(true)
                          }}
                        >
                          로그인
                        </a>
                      }
                    </div>
                    <div className="guide-box gray">
                      <dl className="dlist1">
                        <dt>이용안내</dt>
                        <dd>은행인증서(무료) 또는 범용인증서(유료) 모두 이용 가능합니다.</dd>
                        <dd>비밀번호 5회 이상 입력 오류 시 재시도 해주시기 바랍니다.</dd>
                        <dt>공동인증서 로그인 안내</dt>
                        <dd>인증서 로그인은 전자문서지갑 회원 중 인증서를 등록한 경우 이용 가능합니다.</dd>
                        <dd>'마이페이지 → 인증서관리 → 인증서 등록'에서 등록이 가능합니다.</dd>
                      </dl>
                    </div>
                  </div>
                ))}
              <KTnetModal3
                isKTnetOpen={isKTnetOpen}
                onChange={() => setIsKTnetOpen(false)}
                sendCrtfctInfo={crtfctInfo}
                error={props.error}
              />
            </div>
          </div>
        </div>
        {/* //contents */}
      </div>
      {/* //container */}
      {/* <Alert /> */}
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth.data,
  }
}

const actionCreators = {
  logInCorp: authActions.logInCorp,
  logOut: authActions.logOut,
  memberAppUpdate: memberAppActions.update,
  getCurrentUser: authActions.getCurrentUser,
  getScreenURL: govCertapplyActions.getScreenURL,
  tokenTest: authActions.tokenTest,
  regis: regisActions.regis,
  error: alertActions.error,
  checkUuid: authActions.checkUUID,
  passCrtfctfLogin: authActions.passCrtfctfLogin,
  passCrtfctfLoginIos: authActions.passCrtfctfLoginIos,
  setSignData : userinfoActions.setSignData,
}

export default connect(mapStateToProps, actionCreators)(LoginCorp)
